import AdminEleven from "@/layouts/AdminEleven.vue";

export const marketplaceRoutes = [
  {
    path: "/marketplace",
    component: AdminEleven,
    props: {
      withSearchInput: false,
    },
    children: [
      {
        name: "marketplaceConsumer",
        path: "/consumidor",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/views/marketplace/Consumer.vue"
          ),
        meta: {
          title: "Marketplace/Consumidor",
          requiresAuth: true,
          requiresAdminProfile: true,
        },
      },
      {
        name: "marketPlaceConsumerSettings",
        path: "/consumidor/:type",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/views/marketplace/ConsumerSettings"
          ),
        meta: {
          title: "Marketplace/Consumidor",
          requiresAuth: true,
          requiresAdminProfile: true,
        },
      },
    ],
  },
];
